<template>
    <div>
        <b-button variant="success" @click="pdfgen()">{{ $t('export.search-results.pdf') }}</b-button>
    </div>
</template>

<script>
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import moment from "moment";
pdfMake.vfs = pdfFonts.pdfMake.vfs;

export default {
    props: ["items"],
    data(){
        return {
            styles: {
                header: {
                    fontSize: 12,
                    bold: true
                },
                tableHeader: {
                    fontSize: 6,
                    bold: true,
                    fillColor: 'lightgrey'
                }
	        },
            labels: {
                name: this.$i18n.t('export.fields.name'),
                community_name: this.$i18n.t('export.fields.community-name'),
                supporting_org: this.$i18n.t('export.fields.supporting-org'),
                supporting_org_2: this.$i18n.t('export.fields.supporting-org-2'),
                application_stage: this.$i18n.t('export.fields.application-stage'),
                approval_date: this.$i18n.t('export.fields.approval-date'),
                status: this.$i18n.t('export.fields.status'),
                province: this.$i18n.t('export.fields.province'),
                territory: this.$i18n.t('export.fields.territory'),
                request_approval_entity: this.$i18n.t('export.fields.request-approval-entity'),
                area: this.$i18n.t('export.fields.area'),
                smp_approved: this.$i18n.t('export.fields.smp_approved'),
                smp_approval_date: this.$i18n.t('export.fields.smp_approval_date'),
                potential_mode: this.$i18n.t('export.fields.potential_mode'),
                community_org_type: this.$i18n.t('export.fields.community_org_type'),
                management_plan_approval: this.$i18n.t('export.fields.management_plan_approval'),
                operating_mode: this.$i18n.t('export.fields.operating_mode')
            },
            tableLayouts: {
                cfdbLayout: {
                    hLineWidth: function (i, node) {
                        if (i === 0 || i === node.table.body.length) {
                            return 0;
                        }
                        return (i === node.table.headerRows) ? 2 : 1;
                    },
                    vLineWidth: function (i) {
                        return 0;
                    },
                    hLineColor: function (i) {
                        return i === 1 ? 'black' : '#aaa';
                    },
                    paddingTop: i => {
                        return 4;
                    },
                    paddingLeft: function (i) {
                        return 4;
                    },
                    paddingRight: function (i, node) {
                        return 4;
                    }
                }
            }
        }
    },
    methods: {
        pdfgen(){
            pdfMake.createPdf(this.buildDD(), this.tableLayouts).open()
        },
        buildDD(){
            let dd = {
                pageOrientation: 'landscape',
                pageMargins: [ 10, 30, 10, 30 ],
                defaultStyle: {
                    fontSize: 7
                }
            };
            dd.content = [{text: "CFCL Applications", style: 'header', margin: [0, 10, 0, 10]}];
            dd.styles = this.styles;
            dd.footer = (function (page, pages) {
                            return {
                                columns: [
                                    {text: 'Created ' + moment(Date.now()).format("DD/MM/YYYY") , alignment: 'left', },
                                    {text: ['Page ', { text: page.toString() }, ' of ', { text: pages.toString() }], alignment: 'right',}
                                ],
                                margin: [ 30, 5, 25, 5 ]
                            }
                        });
            let table = {
                layout: 'cfdbLayout',
                table: {
                    headerRows: 1,
                }
            };
            let body = [];
            let headers = []
            for(let header of Object.values(this.labels)){
                headers.push({text: header, style:'tableHeader'})
            }
            body.push(headers);
            for(let item of this.items){
                body.push([
                    item.name, item.community_name, item.supporting_org,
                    item.supporting_org_2, item.application_stage, item.approval_date,
                    item.status, item.province, item.territory, item.request_approval_entity,
                    item.area, item.smp_approved, item.smp_approval_date, item.potential_mode,
                    item.community_org_type, item.management_plan_approval, item.operating_mode
                ])
            }
            table.table.body = body;
            dd.content.push(table)
            return dd;
        }
    }
}
</script>

<style>

</style>
